export const dropdown = `
<svg style="margin-bottom: -5px" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M6.5329 9.2825L8.4754 11.225C8.7679 11.5175 9.2404 11.5175 9.5329 11.225L11.4754 9.2825C11.9479 8.81 11.6104 8 10.9429 8H7.0579C6.3904 8 6.0604 8.81 6.5329 9.2825Z" fill="#55597A"/>
</svg>
`
